var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6v12h24v-12h-24zm22 10h-20v-8h20v8zm-14.812-4.048l-.217-.619-.658.25v-.708h-.643v.706l-.641-.249-.217.619.661.223-.422.559.537.392.397-.586.422.585.527-.392-.422-.558.676-.222zm4 0l-.217-.619-.658.25v-.708h-.643v.706l-.641-.249-.217.619.661.223-.422.559.536.392.398-.586.422.585.527-.392-.422-.558.676-.222zm4 0l-.217-.619-.658.25v-.708h-.643v.706l-.641-.249-.217.619.661.223-.422.559.536.392.398-.586.422.585.527-.392-.422-.558.676-.222zm4.812 2.048h-3v-1h3v1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0737346c4b54c541305b1a75fa44fb6a.svg";
export { ForwardRef as ReactComponent };